import { render, staticRenderFns } from "./FrictionAngleViz.vue?vue&type=template&id=490a53f0&scoped=true"
import script from "./FrictionAngleViz.vue?vue&type=script&lang=js"
export * from "./FrictionAngleViz.vue?vue&type=script&lang=js"
import style0 from "./FrictionAngleViz.vue?vue&type=style&index=0&id=490a53f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a53f0",
  null
  
)

export default component.exports